<template>
  <div>
    <!-- tabs栏 -->
    <div class="tabs">
      <div
        class="tabs_item"
        :class="{ activeTabs: activeTabs == index }"
        @click="changeTabs(index)"
        v-for="(item, index) in tabsList"
        :key="index"
      >{{ item }}</div>
    </div>
    <!-- 无 -->
    <div v-if="noteList.length == 0" class="none">
      <div>还没有笔记哦~</div>
      <!--<div class="none_btn"></div>-->
      <el-button type="success" @click="$router.push('/study')" round >我的课程</el-button>
    </div>
    <!-- 笔记列表 -->
    <div v-else class="note_list" v-for="(item, index) in noteList" :key="index">
      <div class="note_item">
        <div class="note_left">
          <img v-if="!img" src="../../assets/img/home/img8.png" alt />
          <img v-else :src="url+img" alt />
        </div>
        <div class="note_right">
          <div class="level">
            <div>{{userInfo.username}}</div>
            <div>{{ item.addtime*1000 | dateFormat }}</div>
          </div>
          <div class="note_desc">{{item.note}}</div>
          <div class="from">
            <div>源自：{{item.vid}}</div>
            <img @click="del(item.id)" src="../../assets/img/personal/icon_5_6.png" alt />
          </div>
        </div>
      </div>
    </div>
    <!-- 分页功能 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage4"
      :page-size="limit"
      layout="total,  prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
  </div>
</template>
<script>
import store from "store";
import { myNote, delNote } from "../../assets/js/api.js";
export default {
  data() {
    return {
      activeTabs: 0,
      limit: 3,
      page: 1,
      total: 0,
      tabsList: ["笔记"],
      noteList: [],
      currentPage4: 1,
      userInfo: "",
      img: "",
      url:"http://education.hnzye.cn",
    };
  },
  mounted() {
    // 我的笔记
    this.getNoteData();
    this.userInfo = store.get("info");
    this.img = store.get("header_img") || "";
    console.log(this.userInfo);
  },
  methods: {
    // 我的笔记数据
    getNoteData() {
      myNote(localStorage.getItem("info"),this.page, this.limit).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.noteList = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 删除
    del(id) {
      console.log(id);

      delNote(id).then((res) => {
        if (res.code == 200) {

          // let i = this.noteList.findIndex((item) => item.id == id);
          // this.noteList.splice(i, 1);
          this.$message.success("已删除");
          this.getNoteData();
          console.log(this.noteList);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    changeTabs(i) {
      this.activeTabs = i;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getNoteData();
      // console.log(`当前页: ${val}`);
    },
  },
};
</script>
<style lang="less" scoped>
.activeTabs {
  background-color: #029aff;
  color: #fff !important;
}
.tabs {
  width: 100%;
  height: 50px;
  border-bottom: 2px solid #029aff;
  display: flex;
  align-items: center;
  .tabs_item {
    padding: 0 30px;
    box-sizing: border-box;
    height: 100%;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
    font-size: 20px;
    color: #343434;
  }
}
.none {
  font-size: 20px;
  color: #9a9a9a;
  margin: 200px auto;
  text-align: center;
  .none_btn {
    width: 180px;
    height: 60px;
    background: #029aff;
    border-radius: 10px;
    margin: 0 auto;
    color: #fff;
    font-weight: 700;
    line-height: 60px;
    margin-top: 20px;
    cursor: pointer;
  }
}
.note_list {
  .note_item {
    display: flex;
    padding-top: 30px;
    padding-bottom: 10px;
    box-sizing: border-box;
    width: 100%;
    border: 1px solid #f2f2f2;
    .note_left {
      margin-right: 10px;
      img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
    }
    .note_right {
      width: 100%;
      .level {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 15px 0;
        div:nth-child(1) {
          font-size: 16px;
          color: #343434;
        }
        div:nth-child(2) {
          font-size: 14px;
          color: #9a9a9a;
        }
      }
      .note_desc {
        font-size: 14px;
        color: #343434;
        line-height: 1.8;
      }
      .from {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        color: #9a9a9a;
        margin-top: 20px;
        img {
          width: 15px;
          height: 16px;
          cursor: pointer;
        }
      }
    }
  }
}
.el-pagination {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: -50px;
  // margin: 30px 0;
  text-align: center;
}
</style>
